// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c70a0212","453":"98cafab4","849":"05c89859","977":"725e7f64"}[chunkId] + ".chunk.js";
};